document.querySelectorAll('.slider').forEach((sliderEl) => {
  // ▼ 各スライダー内の要素を「親スコープ内」で取得（ID重複でも安全）
  const mainEl       = sliderEl.querySelector('#main-swiper');
  const thumbsEl     = sliderEl.querySelector('#thumbs-swiper');
  const mainPrevEl   = sliderEl.querySelector('#main-prev');
  const mainNextEl   = sliderEl.querySelector('#main-next');
  const thumbsPrevEl = sliderEl.querySelector('#thumbs-prev');
  const thumbsNextEl = sliderEl.querySelector('#thumbs-next');


  /* サムネイルスライダー */
  const thumbsSwiper = new Swiper(thumbsEl, {
    slidesPerView: 8,
    slidesPerGroup: 8,
    spaceBetween: 4,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    allowTouchMove: true,
    navigation: {
      // 文字列セレクタではなく、要素を直接渡す
      nextEl: thumbsNextEl,
      prevEl: thumbsPrevEl
    },
    breakpoints: {
      768: {
        slidesPerView: 11,
        slidesPerGroup: 11
      }
    }
  });

  /* メインスライダー */
  const mainSwiper = new Swiper(mainEl, {
    slidesPerView: 1,
    loop: false,
    spaceBetween: 0,
    navigation: {
      nextEl: mainNextEl,
      prevEl: mainPrevEl
    },
    thumbs: { swiper: thumbsSwiper }
  });
});



//アンカー遷移のズレ補正（ヘッダー分オフセット）
/* ▼ 必要があれば微調整用の追加オフセット(px) */
const EXTRA_OFFSET = 0;

/* ▼ 固定ヘッダーの高さを推定して返す */
function getHeaderOffset() {
  // Impact系で使われやすいセレクタを順にチェック（存在するもののうち最大の高さを採用）
  const selectors = [
    'sticky-header',
    'header[is="sticky-header"]',
    '.shopify-section-header',
    'header.header',
    '.header',
  ];

  let max = 0;
  selectors.forEach(sel => {
    document.querySelectorAll(sel).forEach(el => {
      const style = window.getComputedStyle(el);
      // 画面上部に固定されている要素のみ対象（position: fixed / sticky & topが見える）
      const isFixedOrSticky = /fixed|sticky/i.test(style.position);
      const rect = el.getBoundingClientRect();
      const touchesTop = rect.top <= 0 && rect.bottom > 0;
      if (isFixedOrSticky && touchesTop) {
        max = Math.max(max, rect.height);
      }
    });
  });

  return Math.round(max) + EXTRA_OFFSET;
}

/* ▼ スムーススクロール本体 */
function smoothScrollToTarget(target) {
  if (!target) return;

  // ドキュメント内での絶対位置
  const targetTop = window.pageYOffset + target.getBoundingClientRect().top;

  // 固定ヘッダー分を引く
  const offset = getHeaderOffset();
  const finalTop = Math.max(0, targetTop - offset);

  // iOSのアニメーション競合を避けるため少し待ってからスクロールすることも
  window.requestAnimationFrame(() => {
    window.scrollTo({ top: finalTop, behavior: 'smooth' });
  });
}

/* ▼ ハッシュ文字列から要素を取得（#id / 空は無視） */
function getTargetFromHash(hash) {
  if (!hash || hash === '#') return null;
  try {
    return document.querySelector(hash);
  } catch (_) {
    return null;
  }
}

/* ▼ クリック時に既存のスムーススクロールを止めて自前で制御 */
function handleClick(e) {
  // このページ内のみを対象に、.btn_onepiece_buy などのアンカーを拾う
  const a = e.target.closest('a[href^="#"], .btn_onepiece_buy[href^="#"]');
  if (!a) return;

  const href = a.getAttribute('href');
  const target = getTargetFromHash(href);
  if (!target) return;

  // 既存スクリプトのスクロールを無効化（競合防止）
  e.preventDefault();
  e.stopPropagation();

  // URLのハッシュは更新しておく（履歴に残したい場合）
  if (history.pushState) {
    history.pushState(null, '', href);
  } else {
    location.hash = href;
  }

  smoothScrollToTarget(target);
}

/* ▼ ハッシュが変わったとき（別JSやブラウザUIからの遷移も補正） */
function handleHashChange() {
  const target = getTargetFromHash(location.hash);
  if (target) {
    // ブラウザのデフォルトスクロール後に少し待って補正
    setTimeout(() => smoothScrollToTarget(target), 0);
  }
}

/* ▼ 初期化 */
function initLpAnchorFix() {
  // ページ内リンクのクリックを監視（このページだけで読み込まれる前提なので全体に付与OK）
  document.addEventListener('click', handleClick, true);

  // ハッシュ変更も補正
  window.addEventListener('hashchange', handleHashChange);

  // 初回ロードでハッシュが付いていたら補正
  if (location.hash) {
    // レイアウト確定後に実行（画像やフォントでレイアウトが動くのを考慮）
    window.addEventListener('load', () => handleHashChange());
    // 早めにも一度（必要なら）
    document.addEventListener('DOMContentLoaded', () => handleHashChange());
  }
}

initLpAnchorFix();